import { render, staticRenderFns } from "./socDetailChart.vue?vue&type=template&id=181d5b84"
import script from "./socDetailChart.vue?vue&type=script&lang=js"
export * from "./socDetailChart.vue?vue&type=script&lang=js"
import style0 from "./socDetailChart.vue?vue&type=style&index=0&id=181d5b84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports